import { BackgroundImage, Box, SimpleGrid, Text, Anchor, Stack, Title, List } from '@mantine/core';
import { SignInForm } from '@medplum/react';
import { useNavigate } from 'react-router-dom';
import { MEDPLUM_PROJECT_ID, MEDPLUM_GOOGLE_CLIENT_ID, MEDPLUM_RECAPTCHA_SITE_KEY } from '../config';
import backgroundImage from '../img/homePage/annie-spratt-6a3nqQ1YwBw-unsplash.jpg';
import { useEffect, useState, type JSX } from 'react';

export function SignInPage(): JSX.Element {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  
  // Check window size on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Check initially
    checkMobile();
    
    // Add resize listener
    window.addEventListener('resize', checkMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  return (
    <SimpleGrid cols={isMobile ? 1 : 2} spacing={0}>
      <Box 
        pt={isMobile ? 50 : 100} 
        pb={isMobile ? 50 : 200}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          width: '100%'
        }}
      >
        <Box 
          style={{
            maxWidth: 450,
            width: '100%',
            margin: '0 auto',
            padding: isMobile ? '0 16px' : 0
          }}
        >
          <Stack align="center" mb="md">
            <Title order={2} c="teal.6" fw={700} style={{ fontFamily: 'Poppins, sans-serif' }}>Welcome Back</Title>
            <Text c="dimmed">Sign in to access your personal wellness space</Text>
          </Stack>
          
          <div style={{
              '--mantine-primary-color': '#14b8a6',
              '--mantine-primary-color-light': '#5eead4',
            } as React.CSSProperties}>
            <SignInForm
              projectId={MEDPLUM_PROJECT_ID}
              //googleClientId={MEDPLUM_GOOGLE_CLIENT_ID}
              // Add scope for offline access to get refresh tokens
              scope="openid offline_access"
              // recaptchaSiteKey no longer supported in SignInForm
              onSuccess={() => navigate('/')}
            />
          </div>
          
          <Box mt={20} style={{ textAlign: 'center' }}>
            <Text size="sm">
              Don't have an account?{' '}
              <Anchor onClick={() => navigate('/register')} c="teal.6">
                Sign up
              </Anchor>
            </Text>
            <Text size="sm" mt={10}>
              <Anchor onClick={() => navigate('/resetpassword')} c="teal.6">
                Forgot your password?
              </Anchor>
            </Text>
          </Box>
        </Box>
      </Box>
      
      {!isMobile && (
        <BackgroundImage 
          src={backgroundImage} 
          style={{
            height: '100vh',
            position: 'relative'
          }}
        >
          <Box 
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(20, 184, 166, 0.3)',
              backdropFilter: 'blur(4px)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '4rem'
            }}
          >
            <Box maw={450} c="white">
              <Title order={1} mb="lg" style={{ fontFamily: 'Poppins, sans-serif' }}>Continue Your Journey</Title>
              <Text size="lg" mb="xl">
                We're glad to see you back. Your wellness matters to us.
              </Text>
              <List spacing="sm" size="lg">
                <List.Item icon="✓">Continue your emotional wellness journey</List.Item>
                <List.Item icon="✓">Reflect on your growth and insights</List.Item>
                <List.Item icon="✓">Engage with supportive guidance and resources</List.Item>
              </List>
            </Box>
          </Box>
        </BackgroundImage>
      )}
    </SimpleGrid>
  );
}